import {
  PRODUCT_RENDER_KEYS,
  type ProductRenderKey,
} from '../constants/product-renders';

export function defaultProductRenderKey(
  containerType: string | null,
): ProductRenderKey {
  switch (containerType) {
    case 'DUMPSTER':
      return 'rolloff-20yd';
    case 'FRONT_LOAD':
      return 'frontload-4yd';
    case 'CART':
      return 'toter-96gal';
    default:
      // Liquid-waste products include toilets, sinks, and tanks. Their shared
      // type cannot safely identify a particular piece of equipment.
      return 'generic-box';
  }
}

export function onlineOrderingProductImage(
  product:
    | {
        onlineOrderingImagePath?: string | null;
        imageKey?: string | null;
        containerType?: string | null;
        useIllustrationInOnlineOrdering?: boolean | null;
      }
    | null
    | undefined,
): string | undefined {
  if (product?.onlineOrderingImagePath) return product.onlineOrderingImagePath;
  if (product?.useIllustrationInOnlineOrdering !== true) return undefined;
  const key = PRODUCT_RENDER_KEYS.includes(product.imageKey as ProductRenderKey)
    ? (product.imageKey as ProductRenderKey)
    : defaultProductRenderKey(product.containerType ?? null);
  return `/assets/renders/${key}.webp`;
}

export function isProductIllustrationPath(path: string | undefined): boolean {
  return PRODUCT_RENDER_KEYS.some(
    (key) => path === `/assets/renders/${key}.webp`,
  );
}
